import React, { useCallback, useEffect, useState } from "react";
import SectionHeading from "../../Common/SectionHeading";
import PromotionalCard from "./PromotionalCard";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTranslation } from "react-i18next";
import useApiClient from "hooks/useApiClient";

const PromotionalTours = () => {
    let responsive = {
        0: {
            items: 1,
        },
        600: {
            items: 2,
        },
        960: {
            items: 3,
        },
        1200: {
            items: 4,
        },
    };
    const { t } = useTranslation();
    const [promotionalOffers, setPromotionalOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const { api, urls } = useApiClient();

    const fetchPromotionalOffers = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get(urls.hotel.offers);
            if (response.status === 200 && response.data) {
                setPromotionalOffers(response.data || []);
            }
        } catch (error) {
            console.error("Error fetching promotional offers:", error);
        } finally {
            setLoading(false);
        }
    }, [api, urls.hotel.offers]);

    useEffect(() => {
        fetchPromotionalOffers();
    }, [fetchPromotionalOffers]);

    return (
        <>
            {!promotionalOffers.length && !loading ? (
                <></>
            ) : (
                <section id="promotional_tours" className="section_padding_top">
                    <div className="container">
                        <SectionHeading
                            heading={t("ourBestPromotionalHotels")}
                        />

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="promotional_tour_slider  dot_style">
                                    <OwlCarousel
                                        className="owl-theme"
                                        responsive={responsive}
                                        autoplay={true}
                                        autoplayHoverPause={true}
                                        autoplayTimeout={2500}
                                        loop={false}
                                        margin={10}
                                        nav={false}
                                        dots={true}
                                        key={promotionalOffers.length}
                                    >
                                        {promotionalOffers?.map(
                                            (data, index) => (
                                                <PromotionalCard
                                                    key={index}
                                                    offer={data}
                                                />
                                            )
                                        )}
                                    </OwlCarousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default PromotionalTours;
